import React from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { componentWithFG } from '@atlassian/jira-feature-gate-component';
import { FormattedMessage, type IntlShapeV2 as IntlShape } from '@atlassian/jira-intl';
import type { CloudName } from '@atlassian/jira-shared-types';
import messages from './messages';

type OwnProps = {
	baseUrl: string;
	cloudName: CloudName;
	isSiteAdmin: boolean;
	onUpgrade: () => void;
};

type IntlProps = {
	intl: IntlShape;
};

type Props = OwnProps & IntlProps;

const UPGRADE_URL = '/admin/billing/applications';

export default function DisabledAccessLevel(props: Props) {
	const {
		baseUrl,
		cloudName,
		isSiteAdmin,
		onUpgrade,
		intl: { formatMessage },
	} = props;

	return (
		<DisabledMessage>
			{isSiteAdmin ? (
				<FormattedMessage
					{...messages.disabledProjectAccessMessageSiteAdmin}
					values={{
						cloudName,
						callToAction: (
							<a href={baseUrl + UPGRADE_URL} target="_blank" onClick={onUpgrade}>
								{formatMessage(messages.disabledProjectAccessMessageSiteAdminLink)}
							</a>
						),
					}}
				/>
			) : (
				formatMessage(messages.disabledProjectAccessMessage, {
					cloudName,
				})
			)}
		</DisabledMessage>
	);
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DisabledMessageNew = styled.span({
	font: token('font.body.small'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtle', colors.N100),
	marginLeft: token('space.050', '4px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DisabledMessageOld = styled.span({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtle', colors.N100),
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
	fontSize: '13px',
	marginLeft: token('space.050', '4px'),
});

const DisabledMessage = componentWithFG(
	'hix-5072_use_tokens_in_css',
	DisabledMessageNew,
	DisabledMessageOld,
);
